import {Component, OnInit} from '@angular/core';
import {BlockStatementAbstractComponent} from '../block-statement-abstract.component';

@Component({
    selector: 'core-block-hero-header',
    templateUrl: './block-hero-header.component.html',
    standalone: false
})
export class BlockHeroHeaderComponent extends BlockStatementAbstractComponent implements OnInit {
    logoUrl!: string;
    logoInvertedUrl!: string;
    imageUrl!: string;
    imageAlt!: string;

    override ngOnInit(): void {
        super.ngOnInit();
        this.logoUrl = this.client.getLogoURL();
        this.logoInvertedUrl = this.client.getInvertedLogoURL();
        this.imageUrl = this.client.getHeroImage();
        this.imageAlt = this.client.getHeroImageAlt();
    }

    getSiteName() {
        return this.client.getSiteName();
    }

    getFirstName(): string | false {
        if (!this.authUser) {
            return false;
        }

        return this.authUser.data['FIRST_NAME'] ?? '';
    }

}
